import React from "react";
import { Select } from "antd";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
const { Option } = Select;
const YesNoSelect = (props) => {
  const { onChange, value, disabled, error, popupContainer } = props;

  const yesNoData = [
    { value: true, name: <FormattedMessage id="app.forms.yes" /> },
    { value: false, name: <FormattedMessage id="app.forms.no" /> },
  ];
  return (
    <Select
      onChange={onChange}
      allowClear
      getPopupContainer={(trigger) =>
        popupContainer ? popupContainer : undefined
      }
      style={{
        width: "100%",
        border: error ? "1px solid red" : "initial",
        borderRadius: error ? "5px" : "initial",
      }}
      defaultValue={value}
      disabled={disabled}
    >
      {yesNoData.map((option) => (
        <Option key={option["name"]} value={option["value"]}>
          {option["name"]}
        </Option>
      ))}
    </Select>
  );
};

YesNoSelect.propTypes = {
  onChange: PropTypes.func,
};

export default YesNoSelect;
